import { Outlet, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { GlobalFooter } from './GlobalFooter';
import { GlobalHeader } from './GlobalHeader';

const GLOBAL_HEADER_ROUTES = ['/', '/search', '/publish', '/favorites'];

export function AppLayout() {
  const { pathname } = useLocation();
  const showGlobalHeader = GLOBAL_HEADER_ROUTES.includes(pathname);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        overflow: 'hidden',
      }}
    >
      {showGlobalHeader && <GlobalHeader />}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          overflow: 'auto',
          paddingTop: 'calc(64px + env(safe-area-inset-top))',
          paddingBottom: 'calc(56px + env(safe-area-inset-bottom))',
        }}
      >
        <Outlet />
      </Box>
      <GlobalFooter />
    </Box>
  );
}
